import { css } from '@emotion/core';
import styled from '@emotion/styled';
import {
	BaseCell,
	BaseHeader,
} from '../../../../flights/overview/ui/list/columns/Column';
import {
	ArrowForwardIcon,
	Responsive,
	StyledIconLink,
	StyledLinkText,
} from '../../../../../ui';
import LinkButton from '../../../../../components/common/button/LinkButton';
import { PageRoutes } from '../../../../app/pages/domain/constants/PageRoutes';

interface IDetailsLinkProps {
	slug: string;
	solicitationTitle: string;
}

const styles = css`
	display: flex;
	align-items: flex-start;
	text-align: right;
	width: 120px;
	max-width: 120px;
	padding: 0;

	${StyledIconLink} {
		white-space: nowrap;

		${StyledLinkText} {
			text-overflow: initial;
			overflow: initial;
		}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		align-items: flex-end;
		width: auto;
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
`;

export const StyledCell = styled(BaseCell)`
	${styles};
	font-weight: 500;
	justify-content: flex-end;
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-area: details;
	}
`;

export function Header() {
	return <StyledHeader />;
}

export function Cell({ slug, solicitationTitle }: IDetailsLinkProps) {
	return (
		<StyledCell>
			<LinkButton
				href={`${PageRoutes.CorporateSolicitationsDetails}/${slug}`}
				aria-label={`Details for ${solicitationTitle}`}
				title={`Details for ${solicitationTitle}`}
				buttonType="text"
				icon={<ArrowForwardIcon role="presentation" />}
			>
				Details
			</LinkButton>
		</StyledCell>
	);
}
